import AxiosAcceptPDPA from './axios_PDPA'
const NSGModuleAcceptPDPA = {
  state: {
    stateAcceptPDPA: [],
    stateLogin: [],
    stateGetOTP: [],
    stateSendOTPResetPassword: [],
    // reset pass
    stateResetPasswordByOTP: [],
    stateResetPasswordByEmail: []
  },
  mutations: {
    mutationAcceptPDPA (state, data) {
      state.stateAcceptPDPA = data
    },
    mutationLogin (state, data) {
      state.stateLogin = data
    },
    mutationsGetOTP (state, data) {
      state.stateGetOTP = data
    },
    mutationsSendOTPResetPassword (state, data) {
      state.stateSendOTPResetPassword = data
    },
    // reset pass
    mutationsResetPasswordByOTP (state, data) {
      state.stateResetPasswordByOTP = data
    },
    mutationsResetPasswordByEmail (state, data) {
      state.stateResetPasswordByEmail = data
    }
  },
  actions: {
    async actionAcceptPDPA (context, access) {
      const response = await AxiosAcceptPDPA.axiosAcceptPDPA(access)
      await context.commit('mutationAcceptPDPA', response)
    },

    // login
    async actionLogin (context, access) {
      const response = await AxiosAcceptPDPA.axiosLogin(access)
      await context.commit('mutationLogin', response)
    },

    // login otp
    async actionsGetOTP (context, access) {
      const getOTP = await AxiosAcceptPDPA.GetOTP(access)
      await context.commit('mutationsGetOTP', getOTP)
    },
    async actionsConfirmOTPOneID (context, access) {
      const confirmOTPOneID = await AxiosAcceptPDPA.ConfirmOTPOneID(access)
      await context.commit('mutationsConfirmOTPOneID', confirmOTPOneID)
    },

    // reset pass
    async actionsSendOTPResetPassword (context, access) {
      const response = await AxiosAcceptPDPA.SendOTPResetPassword(access)
      await context.commit('mutationsSendOTPResetPassword', response)
    },
    async actionsResetPasswordByOTP (context, access) {
      const response = await AxiosAcceptPDPA.ResetPasswordByOTP(access)
      await context.commit('mutationsResetPasswordByOTP', response)
    },
    async actionsResetPasswordByEmail (context, access) {
      const response = await AxiosAcceptPDPA.ResetPasswordByEmail(access)
      await context.commit('mutationsResetPasswordByEmail', response)
    }
  }
}

export default NSGModuleAcceptPDPA
